module.exports = __webpack_public_path__ + "img/faee86c.jpg";